module.exports = __webpack_public_path__ + "static/hero-242689c0d623f5e87bb2261a24b72b8e.png";